import { forwardRef, ReactNode, CSSProperties, HTMLAttributes } from 'react'
import { Box, SxProps, Theme } from '@mui/material'
import { getStackStyles } from './styles/stack'

interface StackProps extends Omit<HTMLAttributes<HTMLDivElement>, 'style'> {
  children: ReactNode
  spacing?: number
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse'
  className?: string
  style?: CSSProperties
  flex?: string | number
  wrap?: 'nowrap' | 'wrap' | 'wrap-reverse'
  items?: 'normal' | 'stretch' | 'center' | 'flex-start' | 'flex-end'
  justify?:
    | 'normal'
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'stretch'
  sx?: SxProps<Theme>
}

const Stack = forwardRef<HTMLDivElement, StackProps>(
  (
    {
      className,
      style,
      children,
      direction = 'row',
      spacing = 0,
      flex = '0 1 auto',
      wrap = 'nowrap',
      items = 'normal',
      justify = 'normal',
      sx,
      ...props
    },
    ref
  ) => {
    const stackSx: SxProps<Theme> = getStackStyles({
      spacing,
      direction,
      items,
      justify,
      flex,
      wrap,
    })

    return (
      <Box
        ref={ref}
        className={className}
        style={style}
        sx={[stackSx, ...(Array.isArray(sx) ? sx : [sx])]}
        {...props}
      >
        {children}
      </Box>
    )
  }
)

Stack.displayName = 'Stack'

export default Stack
